module.exports = __webpack_public_path__ + "img/loading.0de00528.svg";